import * as React from "react";
import { ITriggerManualJob } from "../../../redux/types/ITriggerManualJob";
import TextDataInput from "../../../repertoire/components/textDataInput/TextDataInput";
import { triggerManualJob } from "../../../redux/thunks/HomeThunks";
import { ComboBox } from "@fluentui/react";
import { SaveAndClose } from "./SaveAndClose";
import { ControlledMultiselectComboBox } from "../../types/JobParameterControls/MultiselectJobParameterControl";

export interface IMechanicalBackclaimParametersProps     {
    createNewJob: () => any;
    triggerManualJob: typeof triggerManualJob;
    manualJobParameters: ITriggerManualJob;
    formControls: any;
    scheduledJobSet?: (value: boolean) => void;
    onError?: (errorMessage: string) => void;
}

const MechanicalBackclaimParameters = (props: IMechanicalBackclaimParametersProps) => {
    const [data, setData] = React.useState(() => {
        return props.formControls.map(item => {
            const newItem = { ...item };
            if (item.Type === 'combobox') {
                newItem.CurrentValue = item.CurrentValue || '';
            }
            return newItem;
        });
    });

    const [generalError, setGeneralError] = React.useState<string[]>([]);

    const handleTriggerManualJob = async (params) => {
        const errors = validateFields();
        if (errors.length === 0) {
            try { 
                await props.triggerManualJob(data);
                props.scheduledJobSet(true);
                return true;
            } catch (err) {
                props.onError?.(err?.toString() || "An error occurred");
                return false;
            }
        }
        return false;
    };

    const validateFields = (): string[] => {
        let errors: string[] = [];

        data.forEach(item => {
            if (!item.CurrentValue || item.CurrentValue === '' || (Array.isArray(item.CurrentValue) && item.CurrentValue.length === 0)) {
                errors.push(`${item.Caption} is required`);
            }
        });

        setGeneralError(errors);
        return errors;
    };

    const handleChange = (formItem: any, value?: any) => {
        setData(prevState => {
            const newState = prevState.map(item => {
                if (item.ControlID === "MBC_YearsToBackclaim" && formItem.ControlID === "MBC_YearsToBackclaim") {
                    if (value >= 1 && value <= 3) {
                        return { ...item, CurrentValue: value };
                    }
                    return item;
                }

                if (item.ControlID === formItem.ControlID) {
                    return { ...item, CurrentValue: value };
                }
                return item;
            });
            return newState;
        });
    };

    const getFormComponents = (jobControls) => {
        return jobControls.map((formItem) => {
            if(formItem.ControlID === "MBC_SourceDistribution") {
                var options =formItem.DataSourceRepo[formItem.Options].Read()

                return (
                    <div className="form-group col-md-6 col-sm-6 col-xs-12" key={formItem.Caption}>
                        <ControlledMultiselectComboBox
                            caption={formItem.Caption}
                            options={options}
                            defaultValue={formItem.CurrentValue || []}
                            onSelectionChange={(keys) => { handleChange(formItem, keys); }}
                        />
                    </div>
                )
            }
            else if (formItem.ControlID === "MBC_TargetDistribution") {
                var options = formItem.DataSourceRepo[formItem.Options].Read().map((item) => ({ key: item.code, text: item.description }));
            
                return (
                    <div className="form-group col-md-6 col-sm-6 col-xs-12" key={formItem.Caption}>
                        <ComboBox
                            selectedKey={formItem.CurrentValue}
                            label={formItem.Caption}
                            options={options}
                            onChange={(e, selectedOption) => {
                                if (selectedOption) handleChange(formItem, selectedOption.key);
                            }}
                            useComboBoxAsMenuWidth
                            calloutProps={{ calloutMaxHeight: 270 }}
                            autoComplete="on"
                            allowFreeform={true}
                        />
                    </div>
                )
            }
            else if (formItem.ControlID === "MBC_YearsToBackclaim") {
                return (
                    <div className="form-group col-md-6 col-sm-6 col-xs-12" key={formItem.Caption}>
                        <TextDataInput
                            label={formItem.Caption}
                            value={formItem.CurrentValue}
                            changeData={(value) => handleChange(formItem, value)}
                            fieldType={"integer"}
                            fieldName={formItem.ControlID}
                            isHidden={false}
                        />
                    </div>
                )
            }
            
            return null;
        });
    };

    return (
        <div className="form-group col-md-12 col-sm-12 col-xs-12">
            <div className="row">{data && getFormComponents(data)}</div>
            {generalError.length > 0 && (
                <div className="alert alert-danger alert-dismissible">
                    <span>{generalError.join(', ')}</span>
                    <button type="button" className="close" aria-label="Close" onClick={() => setGeneralError([])}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            )}
            <div className="row">
                <SaveAndClose
                    manualJobParameters={props.manualJobParameters}
                    triggerManualJob={handleTriggerManualJob}
                    createNewJob={props.createNewJob}
                    scheduledJobSet={props.scheduledJobSet}
                    onError={props.onError}
                />
            </div>
        </div>
    );
};

export default MechanicalBackclaimParameters;